/**
 * Shared Meta event_id for browser pixel + server CAPI + Everflow adv5 ({adv5}) dedup.
 */
export const createMetaEventId = () =>
  `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`

export default { createMetaEventId }
